import { useState, useEffect } from 'react'
import { AuthProvider, useAuth } from './lib/AuthContext'
import { supabase } from './lib/supabase'
import PaginaAuth from './pages/PaginaAuth'
import PaginaAbbonamento from './pages/PaginaAbbonamento'
import PaginaNotifiche from './pages/PaginaNotifiche'
import HomeAtleta from './pages/HomeAtleta'
import GestioneGruppi from './pages/GestioneGruppi'
import LibreriaEsercizi from './pages/LibreriaEsercizi'
import PannelloAdmin from './pages/PannelloAdmin'
import PaginaProfilo from './pages/PaginaProfilo'
import Onboarding from './pages/Onboarding'
import TopBar from './pages/TopBar'
import PaginaAdesioni from './pages/PaginaAdesioni'
import SponsorBanner from './pages/SponsorBanner'
import SponsorInterstitial from './pages/SponsorInterstitial'
import PaginaSponsor from './pages/PaginaSponsor'
import './index.css'
import { useIndietro } from './lib/navigazioneIndietro'
import { completaIscrizione, parametriIscrizione } from './lib/completaIscrizione'
import { sincronizzaPush } from './lib/pushNotifications'
import { leggiErroreAuth, messaggioErroreAuth } from './lib/erroreAuth'

// Si legge subito, a livello di modulo: il client Supabase ripulisce da sé il
// frammento dell'indirizzo poco dopo l'avvio, quindi un useEffect arriverebbe
// a cose fatte e l'errore sarebbe già sparito.
const ERRORE_AUTH_INIZIALE = typeof window !== 'undefined'
  ? leggiErroreAuth(window.location.hash, window.location.search)
  : null

function ResetPassword() {
  const [nuovaPassword, setNuovaPassword] = useState('')
  const [confermaPassword, setConfermaPassword] = useState('')
  const [errore, setErrore] = useState('')
  const [caricamento, setCaricamento] = useState(false)
  const [completato, setCompletato] = useState(false)
  const [mostraPassword, setMostraPassword] = useState(false)

  async function impostaNuovaPassword() {
    if (!nuovaPassword) { setErrore('Inserisci la nuova password'); return }
    if (nuovaPassword !== confermaPassword) { setErrore('Le password non coincidono'); return }
    setCaricamento(true)
    setErrore('')
    const { error } = await supabase.auth.updateUser({ password: nuovaPassword })
    setCaricamento(false)
    if (error) { setErrore('Errore: ' + error.message); return }
    setCompletato(true)
    await supabase.auth.signOut()
  }

  if (completato) return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24, textAlign: 'center' }}>
      <div style={{ fontSize: 48, marginBottom: 16 }}>ok</div>
      <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 20, marginBottom: 8 }}>Password aggiornata!</div>
      <div style={{ fontSize: 14, color: 'var(--muted)', marginBottom: 32 }}>Ora accedi con la nuova password.</div>
      <button className="btn btn-primary" style={{ maxWidth: 280 }} onClick={() => window.location.href = '/'}>Vai al login</button>
    </div>
  )

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '24px 20px' }}>
      <div style={{ maxWidth: 400, margin: '0 auto', width: '100%' }} className="fade-in">
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <svg viewBox="0 0 226 38" width="192" height="34" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block', margin: '0 auto' }}>
            <circle cx="14" cy="25" r="10" fill="none" stroke="var(--accent)" strokeWidth="3.5"/>
            <circle cx="24" cy="25" r="10" fill="none" stroke="var(--accent)" strokeWidth="3.5"/>
            <text x="41" y="30" fontFamily="Syne, sans-serif" fontWeight="800" fontSize="19" fill="var(--text)">Fit</text>
            <text x="87" y="30" fontFamily="Syne, sans-serif" fontWeight="800" fontSize="19" fill="var(--accent)">Progress</text>
          </svg>
          <div style={{ fontSize: 14, color: 'var(--muted)' }}>Imposta nuova password</div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div className="form-group">
            <label className="form-label">Nuova password</label>
            <div style={{ position: 'relative' }}>
              <input className="form-input" type={mostraPassword ? 'text' : 'password'} value={nuovaPassword} onChange={e => setNuovaPassword(e.target.value)} placeholder="Nuova password" style={{ paddingRight: 44 }} />
              <button type="button" onClick={() => setMostraPassword(v => !v)} style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--muted)', fontSize: 13 }}>
                {mostraPassword ? 'Nascondi' : 'Mostra'}
              </button>
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Conferma password</label>
            <input className="form-input" type={mostraPassword ? 'text' : 'password'} value={confermaPassword} onChange={e => setConfermaPassword(e.target.value)} placeholder="Ripeti la password" />
          </div>
          {errore && <div className="alert alert-warn"><span>!</span><span>{errore}</span></div>}
          <button className="btn btn-primary" onClick={impostaNuovaPassword} disabled={caricamento}>
            {caricamento ? 'Aggiornamento...' : 'Imposta nuova password'}
          </button>
        </div>
      </div>
    </div>
  )
}

function AppContent() {
  const { utente, profilo, caricamento, errore, esci } = useAuth()
  const [tab, setTab] = useState(() => sessionStorage.getItem('fp_tab') || 'home')
  const [homeResetKey, setHomeResetKey] = useState(0)
  const [mostraNotificheAdmin, setMostraNotificheAdmin] = useState(false)
  const [apriRichiesteProfilo, setApriRichiesteProfilo] = useState(false)
  const [isResetMode, setIsResetMode] = useState(false)
  const [mostraOnboarding, setMostraOnboarding] = useState(false)
  const [mostraAbbonamento, setMostraAbbonamento] = useState(false) // upgrade a Coach Premium, non più un gate obbligatorio
  const [mostraPaginaSponsor, setMostraPaginaSponsor] = useState(false)
  const [manutenzione, setManutenzione] = useState(null) // { attiva: bool, messaggio: string }

  // Via di emergenza: se qualcosa impedisce il login/bypass admin normale (sessione corrotta,
  // problema Supabase, ecc.), visitare una volta fitprogress.it/?fp_master=CHIAVE salva il
  // bypass in localStorage e disattiva il controllo manutenzione lato browser, per sempre
  // su quel dispositivo, finché non si rimuove manualmente da localStorage.
  // CAMBIA questa chiave con una a scelta prima del deploy — non serve nessuna modifica al DB.
  const CHIAVE_EMERGENZA = 'lKU9bXiGDuWeAMwmCq2PsqF3'
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const tentativo = params.get('fp_master')
    if (tentativo && tentativo === CHIAVE_EMERGENZA) {
      localStorage.setItem('fp_bypass_manutenzione', 'true')
      params.delete('fp_master')
      const nuovoUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '')
      window.history.replaceState({}, '', nuovoUrl)
    }
  }, [])
  const bypassManutenzione = localStorage.getItem('fp_bypass_manutenzione') === 'true'

  // ── LINK D'INVITO A UN GRUPPO (?invito=TOKEN) ──
  // Il token viene messo da parte subito: se l'utente non è ancora registrato
  // sopravvive al giro di iscrizione e viene usato appena entra.
  const [invitoGruppo, setInvitoGruppo] = useState(null)   // { token, gruppo, coach, valido, motivo }
  const [esitoInvito, setEsitoInvito] = useState('')

  // Link di conferma o recupero non accettato: va detto, non ignorato.
  const [erroreAuth, setErroreAuth] = useState(() => messaggioErroreAuth(ERRORE_AUTH_INIZIALE))
  useEffect(() => {
    if (!ERRORE_AUTH_INIZIALE || !window.location.hash) return
    // Togli il frammento: ricaricando la pagina il messaggio non deve ricomparire
    window.history.replaceState({}, '', window.location.pathname + window.location.search)
  }, [])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const token = params.get('invito') || sessionStorage.getItem('fp_invito')
    if (!token) return
    sessionStorage.setItem('fp_invito', token)
    // ripulisce l'indirizzo, così il token non resta nella barra né nei preferiti
    if (params.get('invito')) {
      params.delete('invito')
      window.history.replaceState({}, '', window.location.pathname + (params.toString() ? '?' + params.toString() : ''))
    }
    supabase.rpc('invito_info', { p_token: token }).then(({ data }) => {
      const info = Array.isArray(data) ? data[0] : data
      if (info) setInvitoGruppo({ token, gruppo: info.gruppo_nome, coach: info.coach_nome, valido: info.valido, motivo: info.motivo })
    })
  }, [])

  // Appena c'è un profilo, la richiesta parte da sola
  // Al ritorno dal link di conferma email l'utente è autenticato: qui si completano
  // i passi dell'iscrizione che al momento della registrazione non erano possibili
  // (nessuna sessione): email di benvenuto, referral, abbonamento regalo.
  // È sicuro eseguirlo a ogni accesso: ogni passo è protetto contro i doppioni.
  useEffect(() => {
    if (!profilo?.id) return
    completaIscrizione(parametriIscrizione())
  }, [profilo?.id])

  // Notifiche push: a ogni avvio si controlla che l'iscrizione del dispositivo
  // risulti ancora registrata nel database, e se manca la si riscrive.
  // Serve perché le due metà possono separarsi senza che nessuno se ne accorga
  // (iscrizione rinnovata dal browser, riga rimossa lato server): da fuori
  // sembra tutto attivo, ma le notifiche non arrivano più. Non chiede permessi
  // e non fa nulla se l'utente non le ha mai attivate.
  useEffect(() => {
    if (!profilo?.id) return
    sincronizzaPush(profilo.id)
  }, [profilo?.id])

  useEffect(() => {
    if (!profilo?.id || !invitoGruppo?.valido) return
    let annullato = false
    supabase.rpc('usa_invito', { p_token: invitoGruppo.token }).then(({ data, error }) => {
      if (annullato) return
      sessionStorage.removeItem('fp_invito')
      setInvitoGruppo(null)
      if (error) return
      const esito = data?.esito
      if (esito === 'richiesta_inviata') setEsitoInvito(`Richiesta inviata a "${data.gruppo}". Il coach deve approvarla.`)
      else if (esito === 'gia_membro') setEsitoInvito(`Sei già nel gruppo "${data.gruppo}".`)
      else if (esito === 'gia_richiesto') setEsitoInvito('Hai già una richiesta in attesa per questo gruppo.')
      else if (esito === 'sei_il_coach') setEsitoInvito('Questo è il link del tuo gruppo: condividilo con i tuoi atleti.')
    })
    return () => { annullato = true }
  }, [profilo?.id, invitoGruppo])

  // Inizializza tema al caricamento
  useEffect(() => {
    const tema = localStorage.getItem('fp_tema')
    if (tema === 'light') {
      document.documentElement.setAttribute('data-theme', 'light')
    }
  }, [])

  // Controlla flag manutenzione da Supabase
  useEffect(() => {
    async function controllaManut() {
      const { data } = await supabase.from('impostazioni_app').select('valore').eq('chiave', 'manutenzione').maybeSingle()
      if (data?.valore) {
        try { setManutenzione(JSON.parse(data.valore)) } catch {}
      }
    }
    controllaManut()
  }, [])

  // Intercetta evento PASSWORD_RECOVERY da Supabase
  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') {
        setIsResetMode(true)
      }
    })
    return () => subscription.unsubscribe()
  }, [])

  useEffect(() => {
    if (!utente) {
      sessionStorage.removeItem('fp_tab')
      setTab('home')
    }
  }, [utente])

  // Mostra onboarding al primo accesso — basato su un campo del database (ruolo_scelto),
  // non più su localStorage: funziona su qualsiasi browser/dispositivo, senza dipendere
  // da cache locale o dal momento esatto del deploy.
  // L'admin non ha bisogno di scegliere un ruolo, quindi salta sempre l'onboarding.
  useEffect(() => {
    if (utente && profilo && profilo.piano !== 'admin' && !profilo.ruolo_scelto) {
      setMostraOnboarding(true)
    } else if (profilo?.ruolo_scelto) {
      setMostraOnboarding(false)
    }
  }, [utente, profilo])

  // Tasto indietro dai tab secondari: torna alla Home invece di chiudere l'app
  // (comportamento standard delle app Android). I tab 'gruppiatleta' e
  // 'progressiatleta' sono esclusi: li gestisce HomeAtleta, che li apre e chiude.
  useIndietro(['esercizi', 'adesioni', 'profilo', 'gruppi', 'admin'].includes(tab), () => cambiaTab('home'))

  function cambiaTab(nuovoTab) {
    if (nuovoTab === 'home' && tab === 'home') {
      // Già su home: forza reset incrementando il key
      setHomeResetKey(k => k + 1)
    }
    setTab(nuovoTab)
    sessionStorage.setItem('fp_tab', nuovoTab)
  }

  const schermataCaricamento = (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 16 }}>
      <svg viewBox="0 0 226 38" width="192" height="34" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block', margin: '0 auto' }}>
        <circle cx="14" cy="25" r="10" fill="none" stroke="var(--accent)" strokeWidth="3.5"/>
        <circle cx="24" cy="25" r="10" fill="none" stroke="var(--accent)" strokeWidth="3.5"/>
        <text x="41" y="30" fontFamily="Syne, sans-serif" fontWeight="800" fontSize="19" fill="var(--text)">Fit</text>
        <text x="87" y="30" fontFamily="Syne, sans-serif" fontWeight="800" fontSize="19" fill="var(--accent)">Progress</text>
      </svg>
      <div style={{ fontSize: 14, color: 'var(--muted)', animation: 'pulse 1.5s infinite' }}>Caricamento...</div>
    </div>
  )

  if (caricamento) return schermataCaricamento

  // Modalita reset password — mostrata anche se loggato
  if (isResetMode) return <div className="app-shell"><ResetPassword /></div>

  if (!utente) return (
    <div className="app-shell">
      {/* Link di conferma email (o recupero password) rifiutato da Supabase.
          Senza questo avviso la pagina di accesso compariva muta e sembrava
          che l'iscrizione non fosse andata a buon fine. */}
      {erroreAuth && (
        <div style={{ padding: '12px 16px', background: 'rgba(251,191,36,0.12)',
          borderBottom: '1px solid rgba(251,191,36,0.35)', fontSize: 13, lineHeight: 1.5,
          display: 'flex', alignItems: 'flex-start', gap: 10 }}>
          <span style={{ flexShrink: 0 }}>⚠️</span>
          <span style={{ flex: 1 }}>{erroreAuth}</span>
          <button onClick={() => setErroreAuth('')} aria-label="Chiudi messaggio"
            style={{ background: 'none', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: 16, flexShrink: 0 }}>✕</button>
        </div>
      )}
      {/* Chi arriva da un link d'invito deve sapere a cosa si sta iscrivendo */}
      {invitoGruppo && (
        <div style={{ padding: '12px 16px', background: invitoGruppo.valido ? 'rgba(127,214,61,0.12)' : 'rgba(255,120,87,0.12)',
          borderBottom: `1px solid ${invitoGruppo.valido ? 'rgba(127,214,61,0.3)' : 'rgba(255,120,87,0.3)'}`, fontSize: 13, textAlign: 'center' }}>
          {invitoGruppo.valido
            ? <>Ti stai unendo a <strong>{invitoGruppo.gruppo}</strong>{invitoGruppo.coach ? <> di {invitoGruppo.coach}</> : null}. Registrati o accedi per inviare la richiesta.</>
            : invitoGruppo.motivo === 'scaduto' ? 'Questo link d\'invito è scaduto: chiedine uno nuovo al tuo coach.'
            : invitoGruppo.motivo === 'revocato' ? 'Questo link d\'invito non è più valido: chiedine uno nuovo al tuo coach.'
            : 'Link d\'invito non valido.'}
        </div>
      )}
      <PaginaAuth />
    </div>
  )

  if (errore) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 16, padding: 24, textAlign: 'center' }}>
      <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 18 }}>Problema di connessione</div>
      <div style={{ fontSize: 14, color: 'var(--muted)' }}>{errore}</div>
      <button className="btn btn-primary" style={{ maxWidth: 280 }} onClick={() => window.location.reload()}>Ricarica pagina</button>
    </div>
  )

  if (!profilo) return schermataCaricamento

  // Manutenzione — mostrata a tutti tranne admin e chi ha usato la chiave di emergenza
  if (manutenzione?.attiva && profilo?.piano !== 'admin' && !bypassManutenzione) {
    return (
      <div className="app-shell">
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 24px', textAlign: 'center' }}>
          <div style={{ fontSize: 64, marginBottom: 20 }}>🔧</div>
          <div style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: 22, marginBottom: 12 }}>Manutenzione in corso</div>
          <div style={{ fontSize: 14, color: 'var(--muted)', lineHeight: 1.7, maxWidth: 340 }}>
            {manutenzione.messaggio || 'Stiamo aggiornando FitProgress. Torna tra poco!'}
          </div>
          <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 24 }}>fitprogressapp@gmail.com</div>
          <button
            onClick={() => esci()}
            style={{ marginTop: 32, background: 'none', border: 'none', color: 'var(--accent)', fontSize: 13, fontWeight: 700, cursor: 'pointer', textDecoration: 'underline' }}>
            Sei admin? Esci e accedi con l'account giusto
          </button>
        </div>
      </div>
    )
  }

  // Utente bloccato dall'admin
  if (profilo.bloccato) {
    return (
      <div className="app-shell">
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 24px', textAlign: 'center' }}>
          <div style={{ fontSize: 64, marginBottom: 20 }}>🚫</div>
          <div style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: 22, marginBottom: 12 }}>Account sospeso</div>
          <div style={{ fontSize: 14, color: 'var(--muted)', lineHeight: 1.7, marginBottom: 8, maxWidth: 340 }}>
            Il tuo account è stato temporaneamente sospeso.
          </div>
          {profilo.bloccato_motivo && (
            <div style={{ fontSize: 13, color: 'var(--text)', lineHeight: 1.6, marginTop: 12, padding: '12px 16px', background: 'var(--surface)', borderRadius: 12, border: '1px solid var(--border)', maxWidth: 340 }}>
              {profilo.bloccato_motivo}
            </div>
          )}
          <div style={{ fontSize: 13, color: 'var(--muted)', marginTop: 20 }}>
            Per info contatta <a href="mailto:fitprogressapp@gmail.com" style={{ color: 'var(--accent)' }}>fitprogressapp@gmail.com</a>
          </div>
          <button className="btn btn-ghost" onClick={() => supabase.auth.signOut()} style={{ marginTop: 32, maxWidth: 280 }}>
            Esci dall'account
          </button>
        </div>
      </div>
    )
  }

  // ── FREEMIUM ──
  // L'app si apre sempre, per atleta e coach: niente più gate a pagamento in ingresso.
  // coachPremium è calcolato UNA SOLA VOLTA qui e passato giù ai componenti che devono
  // applicare i limiti del piano gratuito (GestioneGruppi, PaginaAdesioni, ecc.).
  // Nota: un abbonamento scaduto non blocca più l'accesso — il coach torna semplicemente
  // al piano gratuito invece di essere buttato fuori dall'app.
  const abbonamentoAlAttivo = profilo.abbonamento_al && new Date(profilo.abbonamento_al) > new Date()
  const coachPremium = !!(profilo.abbonamento_attivo || profilo.regalo || abbonamentoAlAttivo)

  if (mostraOnboarding) {
    return <div className="app-shell"><Onboarding userId={utente.id} onCompleta={() => setMostraOnboarding(false)} /></div>
  }

  if (mostraAbbonamento) {
    return <div className="app-shell"><PaginaAbbonamento onChiudi={() => setMostraAbbonamento(false)} /></div>
  }

  if (mostraPaginaSponsor) {
    return <div className="app-shell"><PaginaSponsor onChiudi={() => setMostraPaginaSponsor(false)} /></div>
  }

  const isAdmin = profilo?.piano === 'admin'
  const isCoach = profilo?.piano === 'coach' || isAdmin
  const coachAccessoPremium = isAdmin || coachPremium // l'admin ha sempre accesso pieno
  // Sponsor: mai per admin, mai per chi già paga Premium — solo atleti e coach Free
  const mostraSponsor = !isAdmin && !(isCoach && coachAccessoPremium)

  const navItems = isAdmin
    ? [
        { id: 'home', label: 'HOME' },
        { id: 'admin', label: 'ADMIN' },
        { id: 'profilo', label: 'PROFILO' },
      ]
    : isCoach
    ? [
        { id: 'home', label: 'HOME' },
        // I gruppi sono la funzione centrale del coach: prima si raggiungevano solo
        // toccando un riquadro della home che sembrava una statistica
        { id: 'gruppi', label: 'GRUPPI' },
        { id: 'adesioni', label: 'ADESIONI' },
        { id: 'esercizi', label: 'ESERCIZI' },
        { id: 'profilo', label: 'PROFILO' },
      ]
    : [
        { id: 'home', label: 'HOME' },
        { id: 'adesioni', label: 'ADESIONI' },
        { id: 'esercizi', label: 'ESERCIZI' },
        { id: 'profilo', label: 'PROFILO' },
      ]

  const tabValido = (navItems.find(t => t.id === tab) || tab === 'gruppiatleta' || tab === 'progressiatleta' || tab === 'gruppi' || tab === 'gruppi_iscritto' || tab === 'adesioni') ? tab : 'home'

  const NAV_SVG = {
    home: <svg viewBox="0 0 24 24" width="22" height="22"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
    gruppi: <svg viewBox="0 0 24 24" width="22" height="22"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
    esercizi: <svg viewBox="0 0 24 24" width="22" height="22"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
    admin: <svg viewBox="0 0 24 24" width="22" height="22"><circle cx="12" cy="12" r="3"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14M4.93 4.93a10 10 0 0 0 0 14.14"/></svg>,
    gruppiatleta: <svg viewBox="0 0 24 24" width="22" height="22"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
    progressiatleta: <svg viewBox="0 0 24 24" width="22" height="22"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>,
    adesioni: <svg viewBox="0 0 24 24" width="22" height="22"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>,
    profilo: <svg viewBox="0 0 24 24" width="22" height="22"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>,
  }

  return (
    <div className="app-shell">
      {/* Esito dell'ingresso tramite link d'invito. Sta in cima: prima era in fondo
          alla pagina, sotto la barra di navigazione, e l'atleta non lo vedeva mai —
          apriva il link e sembrava non fosse successo nulla. */}
      {esitoInvito && (
        <div style={{ padding: '12px 16px', background: 'rgba(127,214,61,0.14)', borderBottom: '1px solid rgba(127,214,61,0.35)',
          fontSize: 13, display: 'flex', alignItems: 'center', gap: 10, position: 'relative', zIndex: 60 }}>
          <span style={{ flex: 1 }}>{esitoInvito}</span>
          <button onClick={() => setEsitoInvito('')} aria-label="Chiudi messaggio"
            style={{ background: 'none', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: 16 }}>✕</button>
        </div>
      )}
      {isAdmin && mostraNotificheAdmin && (
        <PaginaNotifiche
          onChiudi={() => setMostraNotificheAdmin(false)}
          onNavigate={(dest, richiestaId) => {
            setMostraNotificheAdmin(false)
            if (dest === 'richieste') {
              sessionStorage.setItem('fp_admin_tab', 'richieste')
              cambiaTab('admin')
            }
            // Notifiche sessione/messaggio non applicabili all'admin
          }}
        />
      )}
      {isAdmin && !mostraNotificheAdmin && tabValido === 'home' && (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }} className="fade-in">
          <TopBar onNotifiche={() => setMostraNotificheAdmin(true)} />
          <div className="scroll-area">
            <div style={{ paddingTop: 4 }}>
              <div style={{ fontSize: 11, color: 'var(--muted)', textTransform: 'capitalize' }}>{new Date().toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' })}</div>
              <div style={{ fontSize: 18, marginTop: 2, fontFamily: 'Syne', fontWeight: 700 }}>Pannello di controllo 🛠️</div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div className="card" onClick={() => { sessionStorage.setItem('fp_admin_tab', 'iscritti'); cambiaTab('admin') }} style={{ cursor: 'pointer' }}>
                <div className="card-body" style={{ padding: '14px 12px' }}>
                  <div style={{ fontSize: 22, marginBottom: 6 }}>👥</div>
                  <div style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: 13, marginBottom: 4 }}>Utenti</div>
                  <div style={{ fontSize: 10, color: 'var(--muted)' }}>Gestisci iscritti</div>
                </div>
              </div>
              <div className="card" onClick={() => { sessionStorage.setItem('fp_admin_tab', 'richieste'); cambiaTab('admin') }} style={{ cursor: 'pointer' }}>
                <div className="card-body" style={{ padding: '14px 12px' }}>
                  <div style={{ fontSize: 22, marginBottom: 6 }}>📩</div>
                  <div style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: 13, marginBottom: 4 }}>Richieste</div>
                  <div style={{ fontSize: 10, color: 'var(--muted)' }}>Segnalazioni utenti</div>
                </div>
              </div>
              <div className="card" onClick={() => { sessionStorage.setItem('fp_admin_tab', 'esercizi'); cambiaTab('admin') }} style={{ cursor: 'pointer' }}>
                <div className="card-body" style={{ padding: '14px 12px' }}>
                  <div style={{ fontSize: 22, marginBottom: 6 }}>💪</div>
                  <div style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: 13, marginBottom: 4 }}>Esercizi</div>
                  <div style={{ fontSize: 10, color: 'var(--muted)' }}>Database esercizi</div>
                </div>
              </div>
              <div className="card" onClick={() => { sessionStorage.setItem('fp_admin_tab', 'contenuti'); cambiaTab('admin') }} style={{ cursor: 'pointer' }}>
                <div className="card-body" style={{ padding: '14px 12px' }}>
                  <div style={{ fontSize: 22, marginBottom: 6 }}>📝</div>
                  <div style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: 13, marginBottom: 4 }}>Contenuti</div>
                  <div style={{ fontSize: 10, color: 'var(--muted)' }}>Guida, Privacy, ToS</div>
                </div>
              </div>
              <div className="card" onClick={() => { sessionStorage.setItem('fp_admin_tab', 'contenuti'); sessionStorage.setItem('fp_admin_subtab', 'manutenzione'); cambiaTab('admin') }} style={{ cursor: 'pointer' }}>
                <div className="card-body" style={{ padding: '14px 12px' }}>
                  <div style={{ fontSize: 22, marginBottom: 6 }}>🔧</div>
                  <div style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: 13, marginBottom: 4 }}>Manutenzione</div>
                  <div style={{ fontSize: 10, color: 'var(--muted)' }}>Attiva/disattiva app</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {!isAdmin && (tabValido === 'home' || tabValido === 'gruppiatleta' || tabValido === 'progressiatleta' || tabValido === 'gruppi_iscritto') && <HomeAtleta onCambiaTab={cambiaTab} tabAttivo={tabValido === 'gruppi_iscritto' ? 'gruppiatleta' : tabValido} resetKey={homeResetKey} />}
      {tabValido === 'adesioni' && <PaginaAdesioni onCambiaTab={cambiaTab} coachPremium={coachAccessoPremium} onRichiediUpgrade={() => setMostraAbbonamento(true)} />}
      {tabValido === 'gruppi' && isCoach && <GestioneGruppi tabIniziale="creati" onCambiaTab={cambiaTab} coachPremium={coachAccessoPremium} onRichiediUpgrade={() => setMostraAbbonamento(true)} />}
      {tabValido === 'esercizi' && <LibreriaEsercizi onAvviaOra={!isAdmin ? (ex, carico, elastico, variantiAttrezzo) => {
        sessionStorage.setItem('fp_avvio_rapido', JSON.stringify({ id: ex.id, nome: ex.nome, tipo_misura: ex.tipo_misura, attrezzatura: ex.attrezzatura || [], varianti: ex.varianti || [], regressioni: ex.regressioni || [], consenteElastico: !!ex.consente_elastico, carico: carico || null, elastico: elastico || null, variantiAttrezzo: variantiAttrezzo || [] }))
        cambiaTab('home')
      } : undefined} />}
      {tabValido === 'admin' && isAdmin && <PannelloAdmin />}
      {tabValido === 'profilo' && <PaginaProfilo onTemaChange={() => {}} apriRichieste={apriRichiesteProfilo} onApriRichiesteConsumed={() => setApriRichiesteProfilo(false)} coachPremium={coachAccessoPremium} isCoach={isCoach} onRichiediUpgrade={() => setMostraAbbonamento(true)} />}

      {mostraSponsor && <SponsorInterstitial />}

      <div style={{
        position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)',
        width: '100%', maxWidth: 430, zIndex: 100,
        display: 'flex', flexDirection: 'column',
      }}>
        {mostraSponsor && <SponsorBanner onVediTutti={() => setMostraPaginaSponsor(true)} />}
        <div className="bottom-nav" style={{ position: 'static', left: 'auto', transform: 'none', maxWidth: 'none', zIndex: 'auto' }}>
          {navItems.map(t => (
            <button key={t.id} className={`nav-item ${tabValido === t.id ? 'active' : ''}`} onClick={() => cambiaTab(t.id)}>
              {tabValido === t.id && <div className="nav-active-bar" />}
              <div className="nav-icon">{NAV_SVG[t.id]}</div>
              <div className={`nav-label${navItems.length >= 4 ? ' nav-label-sm' : ''}`}>{t.label}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}

export default function App() {
  return <AuthProvider><AppContent /></AuthProvider>
}
